/* eslint-disable @typescript-eslint/no-unused-vars */
import { put, takeLatest, call, all } from "redux-saga/effects";
import { encryptData } from "../../_common/enode-decode";
import {
  addLeadsDetailsFailure,
  addLeadsDetailsResponseChanged,
  addLeadsDetailsSuccess,
  deleteLeadsDetailsFailure,
  deleteLeadsDetailsResponseChanged,
  deleteLeadsDetailsSuccess,
  fetchLeadsDetailsFailure,
  fetchLeadsDetailsResponseChanged,
  fetchLeadsDetailsSuccess,
  fetchDocumentDetailsResponseChanged,
  fetchDocumentDetailsSuccess,
  getLeadsListFailure,
  getLeadsListResponseChanged,
  getLeadsListSuccess,
  getleadsourceDropdownListFailure,
  getleadsourceDropdownListResponseChanged,
  getleadsourceDropdownListSuccess,
  getProductDropdownListFailure,
  getProductDropdownListResponseChanged,
  getProductDropdownListSuccess,
  searchPreleadListFailure,
  searchPreleadListResponseChanged,
  searchPreleadListSuccess,
  statusListDetailsFailure,
  statusListDetailsResponseChanged,
  statusListDetailsSuccess,
  updateLeadsDetailsFailure,
  updateLeadsDetailsResponseChanged,
  updateLeadsDetailsSuccess,
  fetchDocumentDetailsFailure,
  addDocumentDetailsFailure,
  addDocumentDetailsSuccess,
  addDocumentDetailsResponseChanged,
  appliedLoanDetailsFailure,
  appliedLoanDetailsSuccess,
  appliedLoanDetailsChange,
  leadAppliedLogListFetchResponseChanged,
  leadAppliedLogListFetchFailure,
  leadAppliedLogListFetchSuccess,
  saleAppliedLogListFetchResponseChanged,
  saleAppliedLogListFetchFailure,
  saleAppliedLogListFetchSuccess,
  updateLeadsDocDetailsFailure,
  updateLeadsDocDetailsSuccess,
  updateLeadsDocDetailsResponseChanged,
  getLeadsDocListFailure,
  getLeadsDocListSuccess,
  getLeadsDocListResponseChanged,
  deleteLeadsDocDetailsFailure,
  deleteLeadsDocDetailsSuccess,
  deleteLeadsDocDetailsResponseChanged,
  appliedLoanDetailsResetStart,
  getLeadAppliedListFailure,
  getLeadAppliedListSuccess,
  getLeadAppliedListResponseChanged,
  fetchSicDetailsFailure,
  fetchSicDetailsSuccess,
  fetchSicDetailsResponseChanged,
  addStatusDetailsFailure,
  addStatusDetailsSuccess,
  addStatusDetailsResponseChanged,
  updateStatusDetailsFailure,
  updateStatusDetailsSuccess,
  updateStatusDetailsResponseChanged,
  searchDashboardLeadsSuccess,
  searchDashboardLeadsFailure,
  deleteDashboardLeadsSuccess,
  deleteDashboardLeadsFailure,
  exportDashboardLeadsSuccess,
  exportDashboardLeadsFailure,
  deleteLenderAppliedDetailsSuccess,
  deleteLenderAppliedDetailsResponseChanged,
  deleteLenderAppliedDetailsFailure,
} from "./leads.action";
import LeadsActionTypes from "./leads.types";
import {
  appliedLoanDetailAPI,
  documentDetailsAdd,
  FetchDocumentListDetails,
  fetchListLeadAppliedLog,
  fetchListSaleAppliedLog,
  leadsDetailsAdd,
  leadsDetailsDelete,
  leadsDetailsUpdate,
  leadsDocDetailsDelete,
  leadsDocDetailsUpdate,
  leadsDocGetData,
  leadsDocListGet,
  leadsListForAll,
  leadsListGet,
  leadSourceDropdownListDetails,
  ProductDropdownListForAll,
  getLeadAppliedListGet,
  SearchPreleadListDetails,
  StatusListForAll,
  sicDetailsFetch,
  addStatusDetailsApi,
  updateStatusDetailsApi,
  searchDashboardLeadsAPI,
  deleteDashboardLeadsAPI,
  exportDashboardLeadsAPI,
  lenderAppliedDetailsDelete,
} from "./leads.service";
/** ***************** ADD LEADS DETAILS START *********************** */
export function* addLeadsDetails({ payload }: any) {
  try {
    const key = "CreateLeadsKey";
    const jsonData = {
      Region: payload.region,
      BusinessName: payload.businessName,
      BusinessEntity: payload.businessEntity,
      Telephone: payload.telephone,
      Mobile: payload.mobile,
      AlternateNumber: payload.AlternateNumber,
      BusinessEmail: payload.businessEmail,
      BusinessNumber: payload.businessNumber,
      CustomerName: payload.customerName,
      CustomerFirstName: payload.customerFirstName,
      customerLastName: payload.customerLastName,
      CustomerEmailID: payload.customerEmailID,
      CustomerDOB: payload.customerDOB,
      OfficeAddressLine1: payload.officeAddressLine1,
      OfficeAddressLine2: payload.officeAddressLine2,
      OfficePostCode: payload.officePostCode,
      ResidentAddressLine1: payload.residentAddressLine1,
      ResidentAddressLine2: payload.residentAddressLine2,
      ResidentPostCode: payload.residentPostCode,
      TradingAddressLine1: payload.tradingAddressLine1,
      TradingAddressLine2: payload.tradingAddressLine2,
      TradingPostCode: payload.tradingPostCode,
      IsHomeOwner: payload.isHomeOwner === "false" ? "No" : "Yes",
      IsHavingAnyOtherProperty:
        payload.isHavingAnyOtherProperty === "false" ? "No" : "Yes",
      PropertyAddressLine1: payload.propertyAddressLine1,
      PropertyAddressLine2: payload.propertyAddressLine2,
      PropertyPostCode: payload.propertyPostCode,
      StatusID: payload.statusID,
      LeadSourceID: payload.leadSourceID == null ? 0 : payload.leadSourceID,
      DocType: payload.docType,
      SICCode: payload.SICCode,
      SICCodeDescription: payload.SICCodeDescription,
      ProductID: payload.productID,
      AnnualTurnOver: payload.annualTurnOver,
      AmountRequested: payload.amountRequested,
      PurposeOfFund: payload.purposeOfFund,
      TermOfFundRequired: payload.termOfFundRequired,
      IsOverdraft: payload.isOverdraft === false ? "0" : "1",
      OverdraftLimit: payload.overdraftLimit,
      MonthlyCardTaking: payload.monthlyCardTaking,
      NoOfLocations: payload.noOfLocations,
      NoOfCardTerminals: payload.noOfCardTerminals,
      NumberOfOutlets: payload.NumberOfOutlets,
      NumberOfCardMachines: payload.NumberOfCardMachines,
      MerchantProvider: payload.merchantProvider,
      PropertyType: payload.propertyType,
      PropertyAddressToBeSecured: payload.propertyAddressToBeSecured,
      PropertyValue: payload.propertyValue,
      RemainingValueOfmortgageOnProperty:
        payload.remainingValueOfmortgageOnProperty,
      TurnOverBand: payload.turnOverBand,
      PreLeadID: payload.preLeadID,
      BusinessStartDate: payload.businessStartDate,
      IncompleteProposalDate: payload.incompleteProposalDate,
      SubmittedProposalDate: payload.submittedProposalDate,
      Status: payload.status,
      UserName: payload.UserName,
      CompanyID: payload.CompanyID,
      CreatedBy: payload.UserID,
      InCorporationDate: payload.InCorporationDate,
      ResidentHouseNumber: payload.residentHouseNumber,
      UserPhoto: payload.userPhoto,
      UploadFileResponse: payload.uploadFileResponses,
      LeadsDocID: payload.LeadsDocID,
      PropertyHouseNumber: payload.propertyHouseNumber,
      BrokerComments: payload.commands,
      IsLoanApplied: payload.IsLoanApplied,
      // BrokerComments: payload.isLoanApplied,
      InstanceName: payload.InstanceName,
      BranchID: payload.branchID,
      HowSoonFundNeeded: payload.howSoonFundNeeded,
      DocumentList: JSON.stringify(payload.uploadFileResponses).replace(
        /"/g,
        "'",
      ),
      LeadCode: payload.LeadCode,
      noOfEPOS: payload.noOfEPOS,
      eposName: payload.eposName,
      annualCardTurnoverPerOutlet: payload.annualCardTurnoverPerOutlet,
      avgTransactionValue: payload.avgTransactionValue,
      paymentsOverPhoneMOTO: payload.paymentsOverPhoneMOTO,
      onlinePayments: payload.onlinePayments,
      settlementTime: payload.settlementTime,
      bankingWindowClose: payload.bankingWindowClose,
      isIncompleteProposal: payload.isIncompleteProposal,
      UnderContracts: payload.underContracts,
      CurrentProvider: payload.currentProvider,
      CurrentProviderCommands: payload.currentProviderCommands,
      ProviderIntroducedBySeddel: payload.providerIntroducedBySeddel,
      LoanDetailsNoOfMachines: payload.loanDetailsNoOfMachines,
      LoanDetailsNoOfEPOS: payload.loanDetailsNoOfEPOS,
      UnderContractsCommands: payload.underContractsCommands,
      ProductQuestionAnswersJson: payload.productQuestionAnswersJson ?? "",
      ClientIntrestedInBusinessLoan:
        payload.ClientIntrestedInBusinessLoan ?? "",
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(leadsDetailsAdd, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(addLeadsDetailsFailure(responseData.data));
    } else {
      yield put(addLeadsDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(addLeadsDetailsFailure(error));
  }
}

export function* resetAddLeadsResponse() {
  yield put(addLeadsDetailsResponseChanged());
}

export function* onAddLeadsDetails() {
  yield takeLatest(LeadsActionTypes.ADD_LEADS_DETAILS_START, addLeadsDetails);
}

export function* onAddLeadsDetailsResponseReset() {
  yield takeLatest(
    LeadsActionTypes.ADD_LEADS_DETAILS_RESPONSE_RESET,
    resetAddLeadsResponse,
  );
}
/** ***************** ADD LEADS DETAILS END *********************** */

/** *********************  START UPDATE LEADS DETAILS  ******************** */
export function* updateLeadsDetails({ payload }: any) {
  try {
    const key = "UpdateLeadsKey";
    const jsonData = {
      Region: payload.Region,
      BusinessName: payload.businessName,
      BusinessEntity: payload.businessEntity,
      Telephone: payload.telephone,
      Mobile: payload.mobile,
      AIternateNumber: payload.AlternateNumber,
      BusinessEmail: payload.businessEmail,
      BusinessNumber: payload.businessNumber,
      CustomerName: payload.customerName,
      CustomerFirstName: payload.customerFirstName,
      customerLastName: payload.customerLastName,
      CustomerEmailID: payload.customerEmailID,
      CustomerDOB: payload.customerDOB,
      UserPhoto: payload.userPhoto,
      OfficeAddressLine1: payload.officeAddressLine1,
      OfficeAddressLine2: payload.officeAddressLine2,
      OfficePostCode: payload.officePostCode,
      ResidentAddressLine1: payload.residentAddressLine1,
      ResidentAddressLine2: payload.residentAddressLine2,
      ResidentPostCode: payload.residentPostCode,
      TradingAddressLine1: payload.tradingAddressLine1,
      TradingAddressLine2: payload.tradingAddressLine2,
      TradingPostCode: payload.tradingPostCode,
      IsHomeOwner: payload.isHomeOwner === "false" ? "No" : "Yes",
      IsHavingAnyOtherProperty:
        payload.isHavingAnyOtherProperty === "false" ? "No" : "Yes",
      PropertyAddressLine1: payload.propertyAddressLine1,
      PropertyAddressLine2: payload.propertyAddressLine2,
      PropertyPostCode: payload.propertyPostCode,
      StatusID: payload.statusID,
      LeadID: payload.LeadID,
      UserName: payload.UserName,
      LeadSourceID: payload.leadSourceID,
      DocType: payload.docType,
      SICCode: payload.SICCode,
      SICCodeDescription: payload.SICCodeDescription,
      ProductID: payload.productID,
      AnnualTurnOver: payload.annualTurnOver,
      AmountRequested: payload.amountRequested,
      PurposeOfFund: payload.purposeOfFund,
      TermOfFundRequired: payload.termOfFundRequired,
      IsOverdraft: payload.isOverdraft === false ? "0" : "1",
      OverdraftLimit: payload.overdraftLimit,
      MonthlyCardTaking: payload.monthlyCardTaking,
      NoOfLocations: payload.noOfLocations,
      NoOfCardTerminals: payload.noOfCardTerminals,
      NumberOfOutlets: payload.NumberOfOutlets,
      NumberOfCardMachines: payload.NumberOfCardMachines,
      MerchantProvider: payload.merchantProvider,
      PropertyType: payload.propertyType,
      PropertyAddressToBeSecured: payload.propertyAddressToBeSecured,
      PropertyValue: payload.propertyValue,
      RemainingValueOfmortgageOnProperty:
        payload.remainingValueOfmortgageOnProperty,
      TurnOverBand: payload.turnOverBand,
      PreLeadID: payload.preLeadID,
      BusinessStartDate: payload.businessStartDate,
      IncompleteProposalDate: payload.incompleteProposalDate,
      SubmittedProposalDate: payload.submittedProposalDate,
      OldBusinessName: payload.OldBusinessName,
      UpdatedBy: payload.UpdatedBy,
      CompanyID: payload.CompanyID,
      Status: payload.status,
      InCorporationDate: payload.InCorporationDate,
      ResidentHouseNumber: payload.residentHouseNumber,
      LeadsDocID: payload.LeadsDocID,
      PropertyHouseNumber: payload.propertyHouseNumber,
      BrokerComments: payload.commands,
      InstanceName: payload.InstanceName,
      BranchID: payload.branchID,
      HowSoonFundNeeded: payload.howSoonFundNeeded,
      LeadCode: payload.LeadCode,
      PreLeadlID: payload.preLeadlID,
      noOfEPOS: payload.noOfEPOS,
      eposName: payload.eposName,
      annualCardTurnoverPerOutlet: payload.annualCardTurnoverPerOutlet,
      avgTransactionValue: payload.avgTransactionValue,
      paymentsOverPhoneMOTO: payload.paymentsOverPhoneMOTO,
      onlinePayments: payload.onlinePayments,
      settlementTime: payload.settlementTime,
      bankingWindowClose: payload.bankingWindowClose,
      isIncompleteProposal: payload.isIncompleteProposal,
      UnderContracts: payload.underContracts,
      CurrentProvider: payload.currentProvider,
      CurrentProviderCommands: payload.currentProviderCommands,
      ProviderIntroducedBySeddel: payload.providerIntroducedBySeddel,
      LoanDetailsNoOfMachines: payload.loanDetailsNoOfMachines,
      LoanDetailsNoOfEPOS: payload.loanDetailsNoOfEPOS,
      UnderContractsCommands: payload.underContractsCommands,
      ProductQuestionAnswersJson: payload.productQuestionAnswersJson ?? "",
      ClientIntrestedInBusinessLoan:
        payload.ClientIntrestedInBusinessLoan ?? "",
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(leadsDetailsUpdate, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(updateLeadsDetailsFailure(responseData.data));
    } else {
      yield put(updateLeadsDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(updateLeadsDetailsFailure(error));
  }
}
export function* resetUpdateLeadsDetailsResponse() {
  yield put(updateLeadsDetailsResponseChanged());
}

export function* onUpdateLeadsDetails() {
  yield takeLatest(
    LeadsActionTypes.UPDATE_LEADS_DETAILS_START,
    updateLeadsDetails,
  );
}

export function* onUpdateLeadsResponseReset() {
  yield takeLatest(
    LeadsActionTypes.UPDATE_LEADS_DETAILS_RESPONSE_RESET,
    resetUpdateLeadsDetailsResponse,
  );
}
/** *********************  END UPDATE LEADS DETAILS ******************** */

/** *********************  START GET LEADS LIST  ******************** */
export function* listAllLeadsData({ payload }: any) {
  try {
    const key = "GetAllLeadsPainatioinKey";
    const {
      CompanyID,
      Limit,
      LeadID,
      searchValueSet,
      InstanceName,
      BranchID,
      UserName,
      UserID,
    } = payload;
    const jsonData = {
      CompanyID: CompanyID,
      Limit: Limit,
      LeadID: LeadID,
      InputSearch: searchValueSet,
      InstanceName: InstanceName,
      BranchID: BranchID || "",
      UserName: UserName || "",
      UserID: UserID,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(leadsListForAll, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getLeadsListFailure(responseData.data));
    } else {
      yield put(getLeadsListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getLeadsListFailure(error));
  }
}

export function* resetGetLeadsListResponse() {
  yield put(getLeadsListResponseChanged());
}

export function* onGetLeadsListDetails() {
  yield takeLatest(LeadsActionTypes.GET_LEADS_LIST_START, listAllLeadsData);
}

export function* onGetLeadsListResponseReset() {
  yield takeLatest(
    LeadsActionTypes.GET_LEADS_LIST_RESPONSE_RESET,
    resetGetLeadsListResponse,
  );
}
/** *********************  END GET LEADS LIST ******************** */

/** *********************  START FETCH LEADS DETAILS  ******************** */
export function* fetchLeadsDetails({ payload }: any) {
  const { LeadID, InstanceName, UserID, CompanyID } = payload;
  try {
    const key = "FetchLeadsKey";
    const jsonData = {
      LeadID: LeadID,
      InstanceName: InstanceName,
      // Carried so the backend anomaly monitor can attribute this "record
      // viewed" to the staff (unusual-activity guard). Harmless if absent.
      UserID: UserID,
      CompanyID: CompanyID,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(leadsListGet, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(fetchLeadsDetailsFailure(responseData.data));
    } else {
      yield put(fetchLeadsDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchLeadsDetailsFailure(error));
  }
}

export function* resetFetchLeadsDetailsResponse() {
  yield put(fetchLeadsDetailsResponseChanged());
}

export function* onFetchLeadsDetails() {
  yield takeLatest(
    LeadsActionTypes.FETCH_LEADS_DETAILS_START,
    fetchLeadsDetails,
  );
}

export function* onFetchLeadsDetailsResponseReset() {
  yield takeLatest(
    LeadsActionTypes.FETCH_LEADS_DETAILS_RESPONSE_RESET,
    resetFetchLeadsDetailsResponse,
  );
}
/** *********************  END FETCH LEADS DETAILS ******************** */

/** *********************  START DELETE LEADS DETAILS  ******************** */
export function* deleteLeads({ payload }: any) {
  const { LeadID, LeadsName, UserName, CompanyID, InstanceName } = payload;
  try {
    const key = "DeleteLeadsKey";
    const jsonData = {
      LeadID: LeadID,
      LeadsName: LeadsName,
      UserName: UserName,
      CompanyID: CompanyID,
      DeletedBy: CompanyID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(leadsDetailsDelete, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(deleteLeadsDetailsFailure(responseData.data));
    } else {
      yield put(deleteLeadsDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(deleteLeadsDetailsFailure(error));
  }
}

export function* resetDeleteLeadsDetailsResponse() {
  yield put(deleteLeadsDetailsResponseChanged());
}

export function* onDeleteLeadsDetails() {
  yield takeLatest(LeadsActionTypes.DELETE_LEADS_DETAILS_START, deleteLeads);
}

export function* onDeleteLeadsDetailsResponseReset() {
  yield takeLatest(
    LeadsActionTypes.DELETE_LEADS_DETAILS_RESPONSE_RESET,
    resetDeleteLeadsDetailsResponse,
  );
}
/** *********************  END DELETE LEADS DETAILS  ******************** */

/** *********************  START GET LEADS LIST  ******************** */
export function* listStatusListData({ payload }: any) {
  try {
    const key = "GetAllLeadsStatusListKey";
    const { Limit, InstanceName } = payload;
    const jsonData = {
      Limit: Limit,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(StatusListForAll, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(statusListDetailsFailure(responseData.data));
    } else {
      yield put(statusListDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(statusListDetailsFailure(error));
  }
}

export function* resetGetStatusListResponse() {
  yield put(statusListDetailsResponseChanged());
}

export function* onGetStatusListDetails() {
  yield takeLatest(
    LeadsActionTypes.STATUS_LIST_DETAILS_START,
    listStatusListData,
  );
}

export function* onGetStatusListResponseReset() {
  yield takeLatest(
    LeadsActionTypes.STATUS_LIST_DETAILS_RESPONSE_RESET,
    resetGetStatusListResponse,
  );
}
/** *********************  END GET LEADS LIST ******************** */

/** *********************  START PRODUCT DROPDOWN LIST DETAILS  ******************** */
export function* listProductDropdownData({ payload }: any) {
  try {
    const { CompanyID, InstanceName } = payload;
    const key = "GetAllProductDropdownListKey";
    const jsonData = {
      CompanyID: CompanyID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(ProductDropdownListForAll, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getProductDropdownListFailure(responseData.data));
    } else {
      yield put(getProductDropdownListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getProductDropdownListFailure(error));
  }
}

export function* resetProductListResponse() {
  yield put(getProductDropdownListResponseChanged());
}

export function* onFetchProductDetails() {
  yield takeLatest(
    LeadsActionTypes.GET_PRODUCT_DROPDOWN_LIST_START,
    listProductDropdownData,
  );
}

export function* onFetchProductListResponseReset() {
  yield takeLatest(
    LeadsActionTypes.GET_PRODUCT_DROPDOWN_LIST_RESPONSE_RESET,
    resetProductListResponse,
  );
}

/** *********************  END PRODUCT DROPDOWN LIST DETAILS  ******************** */

/** *********************  START LEADSOURCE DROPDOWN LIST DETAILS  ******************** */
export function* listLeadsourceDropdownData({ payload }: any) {
  try {
    const key = "FetchAllLeadsSourceKey";
    const { CompanyID, InstanceName } = payload;
    const jsonData = {
      CompanyID: CompanyID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(leadSourceDropdownListDetails, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getleadsourceDropdownListFailure(responseData.data));
    } else {
      yield put(getleadsourceDropdownListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getleadsourceDropdownListFailure(error));
  }
}

export function* resetLeadsourceListResponse() {
  yield put(getleadsourceDropdownListResponseChanged());
}

export function* onFetchLeadsourceDetails() {
  yield takeLatest(
    LeadsActionTypes.GET_LEADSOURCE_DROPDOWN_LIST_START,
    listLeadsourceDropdownData,
  );
}

export function* onFetchLeadsourceListResponseReset() {
  yield takeLatest(
    LeadsActionTypes.GET_LEADSOURCE_DROPDOWN_LIST_RESPONSE_RESET,
    resetLeadsourceListResponse,
  );
}

/** *********************  END LEADSOURCE DROPDOWN LIST DETAILS  ******************** */

/** *********************  START SEARCH PRELEAD LIMIT  ******************** */
export function* searchPreleadLimitDetails({ payload }: any) {
  try {
    const key = "SearchPreLeadMasterKey";
    const {
      BusinessName,
      BusinessNumber,
      SearchToDate,
      SearchFromDate,
      SearchType,
      Limit,
      InstanceName,
    } = payload;
    const jsonData = {
      SearchBusinessName: BusinessName,
      SearchBusinessNumber: BusinessNumber,
      SearchToDate: SearchToDate,
      SearchFromDate: SearchFromDate,
      SearchType: SearchType,
      Limit: Limit,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(SearchPreleadListDetails, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(searchPreleadListFailure(responseData.data));
    } else {
      yield put(searchPreleadListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(searchPreleadListFailure(error));
  }
}

export function* resetSearchPreleadLimitDetails() {
  yield put(searchPreleadListResponseChanged());
}

export function* onSearchPreleadDetails() {
  yield takeLatest(
    LeadsActionTypes.SEARCH_PRELEAD_LIMIT_DETAILS_START,
    searchPreleadLimitDetails,
  );
}

export function* onSearchPreleadResponseReset() {
  yield takeLatest(
    LeadsActionTypes.SEARCH_PRELEAD_LIMIT_DETAILS_RESPONSE_RESET,
    resetSearchPreleadLimitDetails,
  );
}
/** *********************  END SEARCH PRELEAD LIMIT ******************** */

/** *********************  START FETCH LEADS PRODUCT DETAILS  ******************** */
export function* fetchDocumentDetails({ payload }: any) {
  try {
    const key = "FetchAllDocumentKey";
    const jsonData = {
      LeadID: payload.LeadID,
      CompanyID: payload.CompanyID,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(FetchDocumentListDetails, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(fetchDocumentDetailsFailure(responseData.data));
    } else {
      yield put(fetchDocumentDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchDocumentDetailsFailure(error));
  }
}

export function* resetFetchDocumentDetailsResponse() {
  yield put(fetchDocumentDetailsResponseChanged());
}

export function* onFetchDocumentDetails() {
  yield takeLatest(
    LeadsActionTypes.FETCH_DOCUMENT_DETAILS_START,
    fetchDocumentDetails,
  );
}

export function* onFetchDocumentDetailsResponseReset() {
  yield takeLatest(
    LeadsActionTypes.FETCH_DOCUMENT_RESPONSE_RESET,
    resetFetchDocumentDetailsResponse,
  );
}
/** *********************  END FETCH LEADS PRODUCT DETAILS ******************** */

/** ***************** ADD DOCUMENT DETAILS START *********************** */
export function* addDocumentDetails({ payload }: any) {
  try {
    const key = "LeadAttachmentAddKey";
    const jsonData = {
      LeadID: payload.LeadID,
      FileName: payload.Name,
      FileKB: payload.FileKB,
      FileExt: payload.FileExt,
      FileDescription: payload.FileDescription,
      UserID: payload.CreatedID,
      UserName: payload.UserName,
      CompanyID: payload.CompanyID,
      InstanceName: payload.InstanceName,
    };
    console.log("Attachment Details:", jsonData);
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(documentDetailsAdd, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(addDocumentDetailsFailure(responseData.data));
    } else {
      yield put(addDocumentDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(addDocumentDetailsFailure(error));
  }
}

export function* resetAddDocumentResponse() {
  yield put(addDocumentDetailsResponseChanged());
}

export function* onAddDocumentDetails() {
  yield takeLatest(
    LeadsActionTypes.CREATE_DOCUMENT_DETAILS_START,
    addDocumentDetails,
  );
}

export function* onAddDocumentDetailsResponseReset() {
  yield takeLatest(
    LeadsActionTypes.CREATE_DOCUMENT_DETAILS_RESPONSE_RESET,
    resetAddDocumentResponse,
  );
}

/** ***************** ADD DOCUMENT DETAILS END *********************** */

/** ***************** UPDATE DOCUMENT DETAILS START  *********************** */

export function* appliedLoanDetailsStartSaga({ payload }: any) {
  const key: any = "UpdateLoanAppliedKey";
  try {
    const jsonData: any = {
      LeadID: payload.lead_ID,
      UserID: payload.UserID,
      Agentid: payload.Agentid,
      BrokerComments: payload.Comments,
      IsLoanApplied: payload.IsLoanApplied,
      LeadStatusID: payload.leadStatusID,
      LeadSicArray: payload.LeadSicArray,
      BusinessName: payload.BusinessName,
      LeadLenderArray: payload.LeadLenderArray,
      InstanceName: payload.InstanceName,
      UnderContracts: payload.underContracts,
      CurrentProvider: payload.currentProvider,
      CurrentProviderCommands: payload.currentProviderCommands,
      ProviderIntroducedBySeddel: payload.providerIntroducedBySeddel,
      LoanDetailsNoOfMachines: payload.loanDetailsNoOfMachines,
      LoanDetailsNoOfEPOS: payload.loanDetailsNoOfEPOS,
      UnderContractsCommands: payload.underContractsCommands,
    };
    const appliedData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(appliedLoanDetailAPI, appliedData);
    if (responseData.data.statusCode === "100") {
      yield put(appliedLoanDetailsFailure(responseData.data));
    } else {
      yield put(appliedLoanDetailsSuccess(responseData.data));
    }
  } catch (err) {
    yield put(appliedLoanDetailsFailure(err));
  }
}
export function* appliedLoanDetailsReset() {
  yield put(appliedLoanDetailsChange());
}

export function* appliedLoanDetailsStartWatcher() {
  yield takeLatest(
    LeadsActionTypes.LOAN_APPLIED_DETAILS_START,
    appliedLoanDetailsStartSaga,
  );
}

export function* appliedLoanDetailsResetWatcher() {
  yield takeLatest(
    LeadsActionTypes.LOAN_APPLIED_DETAILS_RESET,
    appliedLoanDetailsReset,
  );
}
/** ***************** UPDATE DOCUMENT DETAILS START  *********************** */

/** *********************** START LEAD  APPLIED LOG  LIST FETCH LIST ************************ */
export function* leadAppliedLogListFetch({ payload }: any) {
  const key: any = "getLeadAppliedLogKey";
  try {
    const jsonData: any = {
      CompanyID: payload.CompanyID,
      leadID: payload.leadID,
      InstanceName: payload.InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(fetchListLeadAppliedLog, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(leadAppliedLogListFetchFailure(responseData.data));
    } else {
      yield put(leadAppliedLogListFetchSuccess(responseData.data));
    }
  } catch (error) {
    yield put(leadAppliedLogListFetchFailure(error));
  }
}

export function* leadAppliedLogFetchResponseReset() {
  yield put(leadAppliedLogListFetchResponseChanged());
}

export function* onFetchListLeadAppliedLog() {
  yield takeLatest(
    LeadsActionTypes.LEAD_APPLIED_LOG_LIST_FETCH_START,
    leadAppliedLogListFetch,
  );
}

export function* onLeadAppliedLogListFetchResponseReset() {
  yield takeLatest(
    LeadsActionTypes.LEAD_APPLIED_LOG_LIST_RESPONSE_RESET_START,
    leadAppliedLogFetchResponseReset,
  );
}
/** *********************** END LEAD  APPLIED LOG  LIST FETCH LIST ************************ */

/** *********************** START SALE APPLIED LOG LIST FETCH ************************ */
export function* saleAppliedLogListFetch({ payload }: any) {
  const key: any = "getSaleAppliedLogKey";
  try {
    const jsonData: any = {
      CompanyID: payload.CompanyID,
      leadID: payload.leadID ?? payload.LeadID,
      InstanceName: payload.InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(fetchListSaleAppliedLog, fetchData);
    const body = responseData.data;
    if (String(body?.statusCode ?? body?.StatusCode ?? "") === "100") {
      yield put(saleAppliedLogListFetchFailure(body));
    } else {
      yield put(saleAppliedLogListFetchSuccess(body));
    }
  } catch (error) {
    yield put(saleAppliedLogListFetchFailure(error));
  }
}

export function* saleAppliedLogFetchResponseReset() {
  yield put(saleAppliedLogListFetchResponseChanged());
}

export function* onFetchListSaleAppliedLog() {
  yield takeLatest(
    LeadsActionTypes.SALE_APPLIED_LOG_LIST_FETCH_START,
    saleAppliedLogListFetch,
  );
}

export function* onSaleAppliedLogListFetchResponseReset() {
  yield takeLatest(
    LeadsActionTypes.SALE_APPLIED_LOG_LIST_RESPONSE_RESET_START,
    saleAppliedLogFetchResponseReset,
  );
}
/** *********************** END SALE APPLIED LOG LIST FETCH ************************ */

/** *********************  START UPDATE LEADS DOCUMENT  DETAILS  ******************** */
export function* updateLeadsDocDetails({ payload }: any) {
  try {
    const key = "UpdateAllDocumentKey";
    const jsonData = {
      FileName: payload.FileName,
      FileDescription: payload.fileDescription,
      LeadAttachmentID: payload.LeadAttachmentID,
      OldFileName: payload.OldFileName,
      CompanyID: payload.CompanyID,
      UserName: payload.UserName,
      UpdatedBy: payload.UserID,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(leadsDocDetailsUpdate, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(updateLeadsDocDetailsFailure(responseData.data));
    } else {
      yield put(updateLeadsDocDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(updateLeadsDocDetailsFailure(error));
  }
}

export function* resetUpdateLeadsDocDetailsResponse() {
  yield put(updateLeadsDocDetailsResponseChanged());
}

export function* onUpdateLeadsDocDetails() {
  yield takeLatest(
    LeadsActionTypes.UPDATE_LEADS_DOC_DETAILS_START,
    updateLeadsDocDetails,
  );
}

export function* onUpdateLeadsDocResponseReset() {
  yield takeLatest(
    LeadsActionTypes.UPDATE_LEADS_DOC_DETAILS_RESPONSE_RESET,
    resetUpdateLeadsDocDetailsResponse,
  );
}
/** *********************  END UPDATE LEADS DOCUMENT  DETAILS ******************** */

/** *********************  START FETCH LEADS DOCUMENT  DETAILS  ******************** */
export function* getLeadsDocDetails({ payload }: any) {
  try {
    const key = "GetAllDocumentKey";
    const jsonData = {
      CompanyID: payload.CompanyID,
      Limit: payload.Limit,
      LeadID: payload.LeadID,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(leadsDocListGet, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getLeadsDocListFailure(responseData.data));
    } else {
      yield put(getLeadsDocListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getLeadsDocListFailure(error));
  }
}

export function* resetGetAllLeadsDocDetailsResponse() {
  yield put(getLeadsDocListResponseChanged());
}

export function* onGetAllLeadsDocDetails() {
  yield takeLatest(
    LeadsActionTypes.GET_LEADS_DOC_LIST_START,
    getLeadsDocDetails,
  );
}

export function* onGetAllLeadsDocDetailsResponseReset() {
  yield takeLatest(
    LeadsActionTypes.GET_LEADS_DOC_LIST_RESPONSE_RESET,
    resetGetAllLeadsDocDetailsResponse,
  );
}
/** *********************  END FETCH LEADS DOCUMENT  DETAILS ******************** */

/** *********************  START DELETE LEADS DOCUMENT  DETAILS  ******************** */
export function* deleteLeadsDoc({ payload }: any) {
  try {
    const key = "DeleteLeadsDocKey";
    const jsonData = {
      UserName: payload.UserName,
      CompanyID: payload.CompanyID,
      DeletedBy: payload.UserID,
      LeadAttachmentID: payload.LeadAttachmentID,
      FileName: payload.FileName,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(leadsDocDetailsDelete, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(deleteLeadsDocDetailsFailure(responseData.data));
    } else {
      yield put(deleteLeadsDocDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(deleteLeadsDocDetailsFailure(error));
  }
}

export function* resetDeleteLeadsDocDetailsResponse() {
  yield put(deleteLeadsDocDetailsResponseChanged());
}

export function* onDeleteLeadsDocDetails() {
  yield takeLatest(
    LeadsActionTypes.DELETE_LEADS_DOC_DETAILS_START,
    deleteLeadsDoc,
  );
}

export function* onDeleteLeadsDocDetailsResponseReset() {
  yield takeLatest(
    LeadsActionTypes.DELETE_LEADS_DOC_DETAILS_RESPONSE_RESET,
    resetDeleteLeadsDocDetailsResponse,
  );
}
/** *********************  END DELETE LEADS DOCUMENT  DETAILS ******************** */

/** *********************  START SEARCH COMPANY LIST  ******************** */
export function* getLeadAppliedDetailsListGet({ payload }: any) {
  try {
    const key = "GetLeadAppliedKey";
    const jsonData = {
      LeadID: payload.LeadID,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(getLeadAppliedListGet, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getLeadAppliedListFailure(responseData.data));
    } else {
      yield put(getLeadAppliedListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getLeadAppliedListFailure(error));
  }
}

export function* resetGetgetLeadAppliedListResponse() {
  yield put(getLeadAppliedListResponseChanged());
}

export function* onGetgetLeadAppliedListDetails() {
  yield takeLatest(
    LeadsActionTypes.GET_LEAD_APPLIED_LIST_START,
    getLeadAppliedDetailsListGet,
  );
}

export function* onGetgetLeadAppliedListResponseReset() {
  yield takeLatest(
    LeadsActionTypes.GET_LEAD_APPLIED_LIST_RESPONSE_RESET,
    resetGetgetLeadAppliedListResponse,
  );
}
/** *********************  END SEARCH COMPANY LIST ******************** */

/** *********************  START FETCH SIC DETAILS  ******************** */
export function* fetchSicData({ payload }: any) {
  try {
    const key = "GetSicKey";
    const jsonData = {
      CompanyID: payload.CompanyID,
      sicID: payload.sicID,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(sicDetailsFetch, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(fetchSicDetailsFailure(responseData.data));
    } else {
      yield put(fetchSicDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchSicDetailsFailure(error));
  }
}

export function* resetFetchSicDetailsResponse() {
  yield put(fetchSicDetailsResponseChanged());
}

export function* onFetchSicDetails() {
  yield takeLatest(LeadsActionTypes.FETCH_SIC_DETAILS_START, fetchSicData);
}

export function* onFetchSicResponseReset() {
  yield takeLatest(
    LeadsActionTypes.FETCH_SIC_DETAILS_RESPONSE_RESET,
    resetFetchSicDetailsResponse,
  );
}
/** *********************  END FETCH SIC DETAILS ******************** */

/** ***************** ADD STATUS DETAILS START *********************** */
export function* addStatusDetails({ payload }: any) {
  const { statusID, UserID, companyId, InstanceName, status } = payload;
  try {
    const key = "statusCreateKey";
    const jsonData = {
      // StatusID: statusID,
      statusName: status,
      createdBy: UserID,
      CompanyID: companyId,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(addStatusDetailsApi, encodeData);

    if (responseData.data.statusCode === "100") {
      yield put(addStatusDetailsFailure(responseData.data));
    } else {
      yield put(addStatusDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(addStatusDetailsFailure(error));
  }
}

export function* resetAddStatusResponse() {
  yield put(addStatusDetailsResponseChanged());
}

export function* onAddStatusDetails() {
  yield takeLatest(LeadsActionTypes.ADD_STATUS_DETAILS_START, addStatusDetails);
}

export function* onAddStatusDetailsResponseReset() {
  yield takeLatest(
    LeadsActionTypes.ADD_STATUS_DETAILS_RESPONSE_RESET,
    resetAddStatusResponse,
  );
}
/** ***************** ADD STATUS DETAILS END *********************** */

/** ***************** UPDATE STATUS DETAILS START *********************** */
export function* updateStatusDetails({ payload }: any) {
  const { statusID, UserID, CompanyID, InstanceName, status } = payload;
  try {
    const key = "UpdateStatusKey";
    const jsonData = {
      statusID: statusID,
      statusName: status,
      updatedBy: UserID,
      CompanyID: CompanyID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(updateStatusDetailsApi, encodeData);

    if (responseData.data.statusCode === "100") {
      yield put(updateStatusDetailsFailure(responseData.data));
    } else {
      yield put(updateStatusDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(updateStatusDetailsFailure(error));
  }
}

export function* resetUpdateStatusResponse() {
  yield put(updateStatusDetailsResponseChanged());
}

export function* onUpdateStatusDetails() {
  yield takeLatest(
    LeadsActionTypes.UPDATE_STATUS_DETAILS_START,
    updateStatusDetails,
  );
}

export function* onUpdateStatusDetailsResponseReset() {
  yield takeLatest(
    LeadsActionTypes.UPDATE_STATUS_DETAILS_RESPONSE_RESET,
    resetUpdateStatusResponse,
  );
}
/** ***************** UPDATE STATUS DETAILS END *********************** */

/** *********************  START DELETE LENDER APPLIED DETAILS  ******************** */
export function* lenderAppliedDelete({ payload }: any) {
  try {
    const key = "DeleteLenderAppliedJsonKey";
    const {
      CompanyID,
      LenderAppliedID,
      UserID,
      UserName,
      InstanceName,
      LenderStatus,
    } = payload;
    const jsonData = {
      CompanyID: CompanyID,
      LenderAppliedID: LenderAppliedID,
      DeletedBy: UserID,
      UserName: UserName,
      InstanceName: InstanceName,
      LenderStatus: LenderStatus,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(lenderAppliedDetailsDelete, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(deleteLenderAppliedDetailsFailure(responseData.data));
    } else {
      yield put(deleteLenderAppliedDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(deleteLenderAppliedDetailsFailure(error));
  }
}

export function* resetDeleteLenderAppliedDetailsResponse() {
  yield put(deleteLenderAppliedDetailsResponseChanged());
}

export function* onDeleteLenderAppliedDetails() {
  yield takeLatest(
    LeadsActionTypes.DELETE_LENDER_APPLIED_DETAILS_START,
    lenderAppliedDelete,
  );
}

export function* onDeleteLenderAppliedResponseReset() {
  yield takeLatest(
    LeadsActionTypes.DELETE_LENDER_APPLIED_DETAILS_RESPONSE_RESET,
    resetDeleteLenderAppliedDetailsResponse,
  );
}
/** *********************  END DELETE LENDER APPLIED DETAILS ******************** */

/** ***************** SEARCH DASHBOARD LEADS START *********************** */
function* searchDashboardLeadsSaga({
  payload,
}: any): Generator<any, void, any> {
  const key = "real_cState_kKey";
  try {
    const {
      BusinessName,
      BusinessNumber,
      ProductID,
      LeadSourceID,
      PhoneNumber,
      SearchToDate,
      SearchFromDate,
      Status,
      LastDialledFromDate,
      LastDialledToDate,
      Applied,
      SubmittedFromDate,
      SubmittedToDate,
      PaidOutFromDate,
      PaidOutToDate,
      Lender,
      DealStatus,
      DocumentType,
      Limit,
      InstanceName,
      CompanyID,
      BranchID,
      UserID,
      UserName,
    } = payload;

    const jsonData = {
      SearchBusinessName: BusinessName,
      SearchBusinessNumber: BusinessNumber,
      SearchProductID: ProductID,
      SearchLeadSourceID: LeadSourceID,
      SearchPhoneNumber: PhoneNumber,
      SearchToDate: SearchToDate,
      SearchFromDate: SearchFromDate,
      SearchType: Status,
      SearchLastDialledFromDate: LastDialledFromDate,
      SearchLastDialledToDate: LastDialledToDate,
      SearchApplied: Applied,
      SearchSubmittedFromDate: SubmittedFromDate,
      SearchSubmittedToDate: SubmittedToDate,
      SearchPaidOutFromDate: PaidOutFromDate,
      SearchPaidOutToDate: PaidOutToDate,
      SearchLender: Lender,
      SearchDealStatus: DealStatus,
      SearchDocumentType: DocumentType,
      Limit: Limit,
      InstanceName: InstanceName,
      CompanyID: CompanyID,
      BranchID: BranchID,
      UserID: UserID,
      UserName: UserName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const response = yield call(searchDashboardLeadsAPI, encodeData);
    if (response.data.status) {
      yield put(searchDashboardLeadsSuccess(response.data));
    } else {
      yield put(searchDashboardLeadsFailure(response.data));
    }
  } catch (error) {
    yield put(searchDashboardLeadsFailure(error));
  }
}

export function* onSearchDashboardLeadsStart() {
  yield takeLatest(
    LeadsActionTypes.SEARCH_DASHBOARD_LEADS_START,
    searchDashboardLeadsSaga,
  );
}

/** ***************** EXPORT DASHBOARD LEADS START *********************** */
function* exportDashboardLeadsSaga({
  payload,
}: any): Generator<any, void, any> {
  const key = "real_cState_kKey";
  try {
    // Reusing payload structure from search as it is usually identical for export
    const {
      BusinessName,
      BusinessNumber,
      ProductID,
      LeadSourceID,
      PhoneNumber,
      SearchToDate,
      SearchFromDate,
      Status,
      LastDialledFromDate,
      LastDialledToDate,
      Applied,
      SubmittedFromDate,
      SubmittedToDate,
      PaidOutFromDate,
      PaidOutToDate,
      Lender,
      DealStatus,
      DocumentType,
      Limit,
      InstanceName,
      CompanyID,
      BranchID,
      UserID,
      UserName,
    } = payload;

    const jsonData = {
      SearchBusinessName: BusinessName,
      SearchBusinessNumber: BusinessNumber,
      SearchProductID: ProductID,
      SearchLeadSourceID: LeadSourceID,
      SearchPhoneNumber: PhoneNumber,
      SearchToDate: SearchToDate,
      SearchFromDate: SearchFromDate,
      SearchType: Status,
      SearchLastDialledFromDate: LastDialledFromDate,
      SearchLastDialledToDate: LastDialledToDate,
      SearchApplied: Applied,
      SearchSubmittedFromDate: SubmittedFromDate,
      SearchSubmittedToDate: SubmittedToDate,
      SearchPaidOutFromDate: PaidOutFromDate,
      SearchPaidOutToDate: PaidOutToDate,
      SearchLender: Lender,
      SearchDealStatus: DealStatus,
      SearchDocumentType: DocumentType,
      Limit: Limit,
      InstanceName: InstanceName,
      CompanyID: CompanyID,
      BranchID: BranchID,
      UserID: UserID,
      UserName: UserName,
    };

    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const response = yield call(exportDashboardLeadsAPI, encodeData);
    if (response.data.status) {
      yield put(exportDashboardLeadsSuccess(response.data));
    } else {
      yield put(exportDashboardLeadsFailure(response.data));
    }
  } catch (error) {
    yield put(exportDashboardLeadsFailure(error));
  }
}

export function* onExportDashboardLeadsStart() {
  yield takeLatest(
    LeadsActionTypes.EXPORT_DASHBOARD_LEADS_START,
    exportDashboardLeadsSaga,
  );
}
/** ***************** EXPORT DASHBOARD LEADS END *********************** */

/** ***************** DELETE DASHBOARD LEADS START *********************** */
function* deleteDashboardLeadsSaga({
  payload,
}: any): Generator<any, void, any> {
  const key = "real_cState_kKey";
  try {
    const jsonData = payload; // Payload is already simple object from component

    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const response = yield call(deleteDashboardLeadsAPI, encodeData);
    if (response.data.status) {
      yield put(deleteDashboardLeadsSuccess(response.data));
    } else {
      yield put(deleteDashboardLeadsFailure(response.data));
    }
  } catch (error) {
    yield put(deleteDashboardLeadsFailure(error));
  }
}

export function* onDeleteDashboardLeadsStart() {
  yield takeLatest(
    LeadsActionTypes.DELETE_DASHBOARD_LEADS_START,
    deleteDashboardLeadsSaga,
  );
}
/** ***************** DELETE DASHBOARD LEADS END *********************** */
/** ***************** SEARCH DASHBOARD LEADS END *********************** */

export function* leadsMasterSaga() {
  yield all([
    call(onUpdateStatusDetails),
    call(onUpdateStatusDetailsResponseReset),
    call(onAddStatusDetailsResponseReset),
    call(onAddStatusDetails),
    call(onAddLeadsDetails),
    call(onAddLeadsDetailsResponseReset),
    call(onUpdateLeadsDetails),
    call(onUpdateLeadsResponseReset),
    call(onGetLeadsListDetails),
    call(onGetLeadsListResponseReset),
    call(onFetchLeadsDetails),
    call(onFetchLeadsDetailsResponseReset),
    call(onDeleteLeadsDetails),
    call(onDeleteLeadsDetailsResponseReset),
    call(onGetStatusListDetails),
    call(onGetStatusListResponseReset),
    call(onFetchProductListResponseReset),
    call(onFetchProductDetails),
    call(onFetchLeadsourceDetails),
    call(onFetchLeadsourceListResponseReset),
    call(onSearchPreleadDetails),
    call(onSearchPreleadResponseReset),
    call(onFetchDocumentDetails),
    call(onFetchDocumentDetailsResponseReset),
    call(onAddDocumentDetails),
    call(onAddDocumentDetailsResponseReset),
    call(appliedLoanDetailsStartWatcher),
    call(appliedLoanDetailsResetWatcher),
    call(onFetchListLeadAppliedLog),
    call(onLeadAppliedLogListFetchResponseReset),
    call(onFetchListSaleAppliedLog),
    call(onSaleAppliedLogListFetchResponseReset),
    call(onDeleteLeadsDocDetails),
    call(onDeleteLeadsDocDetailsResponseReset),
    call(onGetAllLeadsDocDetails),
    call(onGetAllLeadsDocDetailsResponseReset),
    call(onFetchSicResponseReset),
    call(onFetchSicDetails),
    call(onUpdateLeadsDocDetails),
    call(onUpdateLeadsDocResponseReset),
    call(onGetgetLeadAppliedListDetails),
    call(onGetgetLeadAppliedListResponseReset),
    call(onDeleteLenderAppliedDetails),
    call(onDeleteLenderAppliedResponseReset),
  ]);
}
